"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IowsStoreAvailabilityListService_1 = __importDefault(require("../../services/store-availability/IowsStoreAvailabilityListService"));
var StoreAvailabilityQueue_1 = __importDefault(require("./StoreAvailabilityQueue"));
var StoreAvailabilityCache_1 = __importDefault(require("./StoreAvailabilityCache"));
var CacheStoreType_1 = __importDefault(require("../../enums/CacheStoreType"));
var utilities_1 = require("@ikea-aoa/utilities");
var LocalizationService_1 = __importDefault(require("../localization/LocalizationService"));
var ProductService_1 = __importDefault(require("../product/ProductService"));
/**
 * This class is used as a simple interface for store availability services.
 */
var StoreAvailabilityService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    function StoreAvailabilityService(options) {
        this.consumer = null;
        this.contract = null;
        this.localizationPrefixApplication = null;
        this.localizationEndpoints = null;
        this.localizationOverrides = null;
        this.locale = null;
        this.cache = null;
        this.availabilityCache = null;
        this.availabilityQueue = null;
        this.availabilityItemQueue = null;
        this.consumer = options.consumer;
        this.contract = options.contract;
        this.localizationPrefixApplication = options.localizationPrefixApplication;
        this.localizationEndpoints = options.localizationEndpoints;
        this.localizationOverrides = options.localizationOverrides;
        this.locale = options.locale;
        this.cache = options.cache || new utilities_1.GlobalCacheStore();
        var cacheStore = this.cache.getStore(CacheStoreType_1.default.storeAvailability);
        this.availabilityCache = new StoreAvailabilityCache_1.default(this.locale, this.cache);
        this.availabilityQueue = cacheStore.get(this.locale + 'queue') || new StoreAvailabilityQueue_1.default();
        cacheStore.set(this.locale + 'queue', this.availabilityItemQueue);
    }
    /**
     * Fetches and returns store availability.
     *
     * @param storeId Store id.
     * @param items Items.
     * @returns Promise.
     */
    StoreAvailabilityService.prototype.getStoreAvailabilities = function (storeId, items) {
        return __awaiter(this, void 0, void 0, function () {
            var cached, allItems, service, availabilities;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cached = this.availabilityCache.getStoreAvailabilities(storeId, items);
                        if (cached.missing.length === 0) {
                            return [2 /*return*/, cached.availabilities];
                        }
                        this.availabilityQueue.addItems(storeId, cached.missing);
                        return [4 /*yield*/, this.availabilityQueue.retrieveItems()];
                    case 1:
                        allItems = _a.sent();
                        if (!(allItems.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getService()];
                    case 2:
                        service = _a.sent();
                        return [4 /*yield*/, service.getStoreAvailabilities(storeId, allItems)];
                    case 3:
                        availabilities = _a.sent();
                        this.availabilityCache.addStoreAvailabilities(storeId, availabilities);
                        this.availabilityQueue.releaseWaiting();
                        _a.label = 4;
                    case 4: return [2 /*return*/, this.availabilityCache.getStoreAvailabilities(storeId, items).availabilities];
                }
            });
        });
    };
    /**
     * Fetches and returns store availability shopping products.
     *
     * @param storeId Store id.
     * @param items Items.
     * @returns Promise.
     */
    StoreAvailabilityService.prototype.getStoreAvailabilityShoppingProducts = function (storeId, items) {
        return __awaiter(this, void 0, void 0, function () {
            var productService, shoppingProducts, promises, _i, shoppingProducts_1, shoppingProduct;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productService = new ProductService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            locale: this.locale,
                            cache: this.cache
                        });
                        return [4 /*yield*/, productService.getShoppingProducts(items)];
                    case 1:
                        shoppingProducts = _a.sent();
                        promises = [];
                        for (_i = 0, shoppingProducts_1 = shoppingProducts; _i < shoppingProducts_1.length; _i++) {
                            shoppingProduct = shoppingProducts_1[_i];
                            promises.push(this.getStoreAvailabilityShoppingProduct(storeId, shoppingProduct));
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetches and returns store availability shopping product.
     *
     * @param storeId  Store id.
     * @param shoppingProduct Shopping products.
     * @returns Promise.
     */
    StoreAvailabilityService.prototype.getStoreAvailabilityShoppingProduct = function (storeId, shoppingProduct) {
        if (!shoppingProduct.product.content) {
            return null;
        }
        var product = shoppingProduct.product.content;
        var id = product.itemNoLocal || product.itemNoGlobal;
        var storeAvailabilityShoppingProduct = {
            id: id,
            children: null,
            availability: null,
            shoppingProduct: shoppingProduct
        };
        if (product.itemType === 'SPR') {
            return this.getStoreAvailabilityShoppingProductChildren(storeId, shoppingProduct).then(function (children) {
                storeAvailabilityShoppingProduct.children = children;
                return storeAvailabilityShoppingProduct;
            });
        }
        return this.getStoreAvailabilities(storeId, [
            {
                id: id,
                type: product.itemType
            }
        ]).then(function (availabilities) {
            storeAvailabilityShoppingProduct.availability = availabilities[0] || null;
            return storeAvailabilityShoppingProduct;
        });
    };
    /**
     * Fetches and returns store availability.
     *
     * @param storeId Store id.
     * @param shoppingProduct Shopping product.
     * @returns Promise.
     */
    StoreAvailabilityService.prototype.getStoreAvailabilityShoppingProductChildren = function (storeId, shoppingProduct) {
        return __awaiter(this, void 0, void 0, function () {
            var productService, children, promises, product, parentId, _loop_1, this_1, _i, _a, child;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!shoppingProduct.product.content) {
                            return [2 /*return*/, null];
                        }
                        productService = new ProductService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            locale: this.locale,
                            cache: this.cache
                        });
                        children = [];
                        promises = [];
                        product = shoppingProduct.product.content;
                        parentId = product.itemNoLocal || product.itemNoGlobal;
                        _loop_1 = function (child) {
                            var _a = child.itemId.split('-'), type = _a[0], id = _a[1];
                            var storeAvailabilityShoppingProduct = {
                                id: null,
                                children: null,
                                availability: null,
                                shoppingProduct: null
                            };
                            promises.push(this_1.getStoreAvailabilities(storeId, [{ id: id, type: type }]).then(function (availabilities) {
                                return (storeAvailabilityShoppingProduct.availability = availabilities[0] || null);
                            }));
                            promises.push(productService
                                .getShoppingProducts([{ id: id, type: type, quantity: child.quantity }])
                                .then(function (shoppingProducts) {
                                if (shoppingProducts.length > 0 && shoppingProducts[0].product.content) {
                                    var childId = shoppingProducts[0].product.content.itemNoLocal ||
                                        shoppingProducts[0].product.content.itemNoGlobal;
                                    storeAvailabilityShoppingProduct.id = parentId + "/" + childId;
                                    storeAvailabilityShoppingProduct.shoppingProduct = shoppingProducts[0];
                                }
                            }));
                            children.push(storeAvailabilityShoppingProduct);
                        };
                        this_1 = this;
                        for (_i = 0, _a = product.child; _i < _a.length; _i++) {
                            child = _a[_i];
                            _loop_1(child);
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, children];
                }
            });
        });
    };
    /**
     * Returns service.
     *
     * @returns Service.
     */
    StoreAvailabilityService.prototype.getService = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localizationService, localizedInformation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localizationService = new LocalizationService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            localizationOverrides: this.localizationOverrides,
                            locale: this.locale,
                            cache: this.cache
                        });
                        return [4 /*yield*/, localizationService.getLocalizedInformation()];
                    case 1:
                        localizedInformation = _a.sent();
                        return [2 /*return*/, new IowsStoreAvailabilityListService_1.default({
                                consumer: this.consumer,
                                contract: this.contract,
                                endpoint: localizedInformation.endpoints.iowsStoreAvailabilityListService
                            })];
                }
            });
        });
    };
    return StoreAvailabilityService;
}());
exports.default = StoreAvailabilityService;
//# sourceMappingURL=StoreAvailabilityService.js.map